import * as Actions from '../Actions/PrimeirosPassosActions';

const initialState = {
    error: null,
    json: null,
    conteudo: null,
    dialog: null,
};

const PrimeirosPassosReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_JSON:
            {
                return {
                    ...state,
                    json: action.payload,
                    conteudo: null
                };
            }
        case Actions.PRIMEIROSPASSOS_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.GET_CONTEUDO:
            {
                return {
                    ...state,
                    conteudo: action.payload
                };
            }
        case Actions.GET_DIALOG:
            {
                return {
                    ...state,
                    dialog: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = PrimeirosPassosReducer;

export default reducer;